<template>
  <div
    v-if="dataAppointment"
    class="pt-4"
  >

    <b-card
      class="card-profile"
    >
      <div class="profile-image-wrapper">
        <div class="profile-image p-0">
          <b-avatar
            size="110"
            variant="primary"
          />
        </div>
      </div>
      <h3>{{ dataAppointment.patient_name }}</h3>
      <h6 class="text-muted">
        {{ obfuscatePhone(dataAppointment.patient_phone) }}
      </h6>


      <hr class="mb-2">
      <b-badge
        class="profile-badge"
        variant="light-primary"
      >
        {{ dataAppointment.schedule_clinic.name }}
      </b-badge>

      <h6 class="text-muted">
        {{ dataAppointment.schedule_clinic.address }}
      </h6>
      <small>{{ dataAppointment.schedule_clinic.city.name }}</small>
      <hr class="mb-2">

      <!-- follower projects rank -->
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h6 class="text-muted font-weight-bolder">
            Procedimiento
          </h6>
          <h5 class="mb-0">
            {{ dataAppointment.service_type.name }}
          </h5>
          <h6 class="mb-0 text-muted">
            {{ dataAppointment.scan_type ? dataAppointment.scan_type.name : dataAppointment.model_type }}
          </h6>
        </div>
        <div>
          <h6 class="text-muted font-weight-bolder">
            Fecha
          </h6>
          <h5 class="mb-0">
            {{ dataAppointment.formatted_date ? dataAppointment.formatted_date : 'N/A' }}
          </h5>
        </div>
        <div>
          <h6 class="text-muted font-weight-bolder">
            Hora
          </h6>
          <h5  class="mb-0">
            {{ dataAppointment.formatted_time ? dataAppointment.formatted_time : 'N/A' }}
          </h5>
        </div>
      </div>
      <!--/ follower projects rank -->
    </b-card>
  </div>
  <div
    v-else
    md="12"
  >
    <loading-skeleton />
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BInputGroup,
  BInputGroupAppend,
  BAlert,
  BSpinner,
  BCardTitle,
  BCardText,
  BFormDatepicker,
  BButtonGroup,
  BCard, BAvatar, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { codeDisableDate } from '@/views/forms/form-element/form-datepicker/code'
import api from '@/plugin/axios'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import router from '@/router'

export default {
  components: {
    BBadge,
    BAvatar,
    BCard,
    LoadingSkeleton,
    BFormDatepicker,
    BCardText,
    BCardTitle,
    BSpinner,
    BAlert,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    ValidationProvider,
    BButton,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormDatepicker,
    BButtonGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      loadingDate: false,
      password: null,
      userEmail: null,
      user: null,
      dataAppointment: null,
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getDataCreate()
  },
  methods: {
    async getDataCreate() {
      [this.dataAppointment] = await Promise.all([
        api.get(`/api/appointments/${router.currentRoute.params.id}`),
      ])

      console.log(this.dataAppointment)

      this.dataAppointment = this.dataAppointment.data

      // this.patients = this.dataAppointments.data.patients.map(patient => ({ value: patient.id, text: `${patient.full_name} - ${patient.document_type}: ${patient.document_number}` }))
    },

    obfuscatePhone(phone) {
      return `${phone.substring(0, 3)}****${phone.substring(phone.length - 3)}`
    },
  },
}
</script>

<style scoped>
.b-button-group .btn {
  transition: 0.2s;
  font-size: 1.1rem;
}
</style>
